<template>
  <v-expansion-panels v-model="panels" multiple>
    <v-expansion-panel v-for="plan in groupedPlans" :key="plan.planId">
      <v-subheader
        v-if="Boolean(plan.header)"
        class="text-subtitle-1 ma-2 grey lighten-4"
        >{{ plan.header.toUpperCase() }}</v-subheader
      >
      <template v-else>
        <v-expansion-panel-header class="flex-row-reverse">
          <v-card-title>
            <span
              :class="plan.isIncomplete ? 'font-italic' : null"
              :style="$vuetify.breakpoint.xsOnly ? 'flex: 1 1 100%' : ''"
            >
              {{ plan.planType }}: {{ plan.formattedStartDate }}
            </span>
            <div
              v-if="canEdit(plan)"
              :class="$vuetify.breakpoint.xsOnly ? '' : 'ml-4'"
              @click.stop
            >
              <v-switch
                :input-value="isEditing(plan)"
                @change="(val) => setEditing(plan, val)"
                label="Plan Edit mode"
                dense
                hide-details
                class="mt-0 pt-0"
              ></v-switch>
            </div>
            <div class="d-flex flex-nowrap">
              <delete-modal
                v-if="canEdit(plan)"
                :disabled="!canDelete(plan)"
                disabledTooltip="Cannot remove plan with service plans"
                title="Are you sure you want to REMOVE this plan?"
                message="Note: This action cannot be undone."
                @save="deletePlan($event, plan)"
              ></delete-modal>
              <v-tooltip v-if="canReopen(plan)" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    small
                    color="primary"
                    @click="reopenPlan(plan)"
                    >mdi-reload</v-icon
                  >
                </template>
                <span>Reopen plan</span>
                <confirm-modal ref="confirm"></confirm-modal>
              </v-tooltip>
            </div>
          </v-card-title>
        </v-expansion-panel-header>
        <v-subheader v-if="plan.isIncomplete" class="font-italic error--text">
          * Awaiting complete plan details</v-subheader
        >
        <v-expansion-panel-content eager>
          <!-- edit mode -->
          <plan-editor
            v-if="isEditing(plan) && canEdit(plan)"
            :plan="plan"
          ></plan-editor>
          <!-- readonly mode -->
          <plan-view
            v-else
            :plan="plan"
            :canEditAssignments="canEdit(plan)"
          ></plan-view>
        </v-expansion-panel-content>
      </template>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import PlanEditor from "./plan-editor";
import PlanView from "./plan-view";
import DeleteModal from "../../Shared/delete-modal";
import ConfirmModal from "../../Shared/confirm-modal";

export default {
  components: {
    PlanEditor,
    PlanView,
    DeleteModal,
    ConfirmModal,
  },
  props: ["plans", "active"],
  data() {
    return {
      panels: this.active ? [...this.plans.keys()] : [],
      // planIds in edit mode (because toggle is per-plan)
      editingIds: [],
    };
  },
  computed: {
    isSEITOrRSAdmin() {
      return this.$store.getters["securityModule/isSEITOrRSAdmin"];
    },
    planTypes() {
      return this.$store.state.optionsModule.planTypes;
    },
    groupedPlans: function () {
      const groups = Object.groupBy(this.plans, (plan) => plan.ageCategory);
      return Object.keys(groups).flatMap((category) => [
        { header: category },
        ...groups[category],
      ]);
    },
  },
  methods: {
    isEditing(plan) {
      return this.editingIds.includes(plan.planId);
    },
    setEditing(plan, on) {
      if (on) {
        if (!this.editingIds.includes(plan.planId)) {
          this.editingIds.push(plan.planId);
        }
      } else {
        this.editingIds = this.editingIds.filter((id) => id != plan.planId);
      }
    },
    canEdit(plan) {
      return (
        this.isSEITOrRSAdmin &&
        plan.isActive &&
        ["Preschool", "SchoolAge"].includes(plan.ageCategory)
      );
    },
    canDelete(plan) {
      return plan.servicePlans.length == 0;
    },
    canReopen(plan) {
      // can only reopen plan if there are no active plans
      return (
        this.isSEITOrRSAdmin &&
        !plan.isActive &&
        plan.ageCategory == "Preschool" &&
        !this.$store.getters["plansModule/getHasActivePlans"]
      );
    },
    deletePlan: async function (comments, plan) {
      this.$store.commit("uxModule/setShowLoader", true);
      var message = await this.$store.dispatch("plansModule/deletePlan", {
        planId: plan.planId,
        comments: comments,
      });
      this.$store.commit("uxModule/setShowLoader", false);
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
    },
    reopenPlan: async function (plan) {
      if (
        await this.$refs.confirm[0].open(
          "Are you sure you want to reopen this plan?",
          ""
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        var message = await this.$store.dispatch("plansModule/updatePlan", {
          ...plan,
          closureDate: null,
        });
        this.$store.commit("uxModule/setShowLoader", false);
        if (message) {
          this.$store.commit("uxModule/setSnackbarMsg", message);
          this.$store.commit("uxModule/setShowSnackbar", true);
        }
      }
    },
  },
};
</script>
